/* src/app/modules/employees/bajas/bajas-confirm-delete.component.css */
.mr-2 {
  margin-right: 8px;
}
.mb-3 {
  margin-bottom: 16px;
}
.text-danger {
  color: #dc3545;
}
.alert {
  padding: 12px;
  border-radius: 4px;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  margin-bottom: 16px;
}
.row {
  display: flex;
  margin-bottom: 8px;
}
.col-md-4 {
  flex: 0 0 33.333333%;
  font-weight: 500;
}
.col-md-8 {
  flex: 1;
}
mat-dialog-actions,
.mat-mdc-dialog-actions {
  padding: 16px 0;
}
mat-dialog-content,
.mat-mdc-dialog-content {
  min-height: 200px;
}
/*# sourceMappingURL=bajas-confirm-delete.component.css.map */
